import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
import { capitalize } from '../utils';
export var cellWidth = function cellWidth(width) {
  return function () {
    return {
      className: css(styles.modifiers[typeof width === 'number' ? "width_".concat(width) : "width".concat(capitalize(width))])
    };
  };
};